/**
 * State managed across the
 * entire chat screen
 */
import { createContext } from 'use-context-selector';
import { useReducer } from 'react';
import produce from 'immer';
export var GlobalContext = createContext(undefined);
export var GlobalContextAction = createContext(undefined);
export var potatoReducer = function (messages, action) {
    switch (action.type) {
        case 'updateMessage':
            var _a = action.message, input_1 = _a.input, user_1 = _a.user;
            return produce(messages, function (draft) {
                draft.messages.push({
                    // @ts-ignore
                    input: input_1,
                    dateTimeDelta: Date.now(),
                    // dateTimeDelta: Date.now() - (new Date(originDate)).getTime(),
                    user: user_1
                });
            });
        default:
            throw new Error("Unknown action type: " + action.type);
    }
};
// @ts-ignore
export var useGlobalValue = function (globalContext) { return useReducer(potatoReducer, globalContext); };
